module.exports = __webpack_public_path__ + "media/images/turbochargers/Holset_old-cd15c26f51223868d965d88d4168f15a.jpg";